import React, { useEffect, useState } from 'react'
import { INFDetailFormatted } from '../../../components/NFTDetail/INFTDetail'
import Api from '../../../../../services/Api'
import { IBaseNFTAttributes } from '../../../models/INFTProperties'
import BaseDetail from '../../Base/Detail/BaseDetail'
import NFTImageSkeleton from '../../../components/NFTImageSkeleton'
import { IGeneralCard } from '../../Generals/Card/IGeneralCard'
import { NFTPropertyItem } from '../../../components/NFTProperty'
import { RarityData } from '../../../data/NFTCollections/TubbyReindeerData'
import RankData from '../../../data/NFTCollections/TubbyReindeerData.json'

export default function TubbyReindeerDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const [detailTokenItem, setDetailTokenItem] = useState<IGeneralCard | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)

  let tokenName = detailTokenItem && detailTokenItem.name ? detailTokenItem.name : collection.name

  if (detailTokenItem && !detailTokenItem.name) {
    tokenName = detailTokenItem ? `${collection.name} #${tokenItem.tokenId}` : collection.name
  }

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri.replace('ipfs://', 'https://ipfs.io/ipfs/')).then((tokenResult: any) =>
        setDetailTokenItem(tokenResult)
      )
    }
  }, [tokenItem, tokenUriControl])

  function getNFTProperties() {
    let result: any[] = []
    let total = 0

    if (detailTokenItem && detailTokenItem.attributes) {
      const foundRank = tokenItem
        ? RankData.find(item => parseInt(tokenItem.tokenId.toString()) === parseInt(item.tokenId))
        : null

      result = detailTokenItem.attributes
        .filter(item => item.value)
        .map((item: IBaseNFTAttributes, index: number) => {
          const foundDetail = RarityData.find(
            rarityData =>
              rarityData.traitType === item.trait_type && rarityData.value.toLowerCase() === item.value.toLowerCase()
          )
          let color = 'inherit'
          let borderSize = 'inherit'

          if (foundDetail) {
            color = foundDetail.color
            borderSize = '3px'
            total += parseFloat(foundDetail.percent)
          }

          return (
            <NFTPropertyItem key={`PROPERTY_${index}`} className={`property-item`}>
              <div className="wrapper" style={{ borderColor: color, borderWidth: borderSize }}>
                <div className="type" title={item.trait_type}>
                  {item.trait_type}
                </div>
                <div className="name" title={item.value}>
                  <div>{item.value}</div>
                  {foundDetail && (
                    <div>
                      ({foundDetail.rarityType} {foundDetail.percent}%)
                    </div>
                  )}
                </div>
              </div>
            </NFTPropertyItem>
          )
        })

      result.unshift(
        <NFTPropertyItem key={`PROPERTY_PERCENT_TOTAL`} className={`property-item`}>
          <div className="wrapper" style={{ minHeight: '94px' }}>
            <div className="type" title="Rarity Total">
              Rarity Total
            </div>
            <div className="name" title={`${total.toFixed(2)}%`}>
              <div style={{ fontSize: '1.2rem' }}>{total.toFixed(2)}%</div>
            </div>
          </div>
        </NFTPropertyItem>
      )

      if (foundRank) {
        result.unshift(
          <NFTPropertyItem key={`PROPERTY_PERCENT_SCORE`} className={`property-item`}>
            <div className="wrapper" style={{ minHeight: '94px' }}>
              <div className="type" title="Score">
                Score
              </div>
              <div className="name" title={`${foundRank.score}`}>
                <div style={{ fontSize: '1.2rem' }}>{foundRank.score}</div>
              </div>
            </div>
          </NFTPropertyItem>
        )

        result.unshift(
          <NFTPropertyItem key={`PROPERTY_PERCENT_RANK`} className={`property-item`}>
            <div className="wrapper" style={{ minHeight: '94px' }}>
              <div className="type" title="Rank">
                Rank
              </div>
              <div className="name" title={`${foundRank.rank}`}>
                <div style={{ fontSize: '1.2rem' }}>{foundRank.rank}</div>
              </div>
            </div>
          </NFTPropertyItem>
        )
      }
    }

    return result
  }

  return (
    <BaseDetail
      {...props}
      description={detailTokenItem ? <div>{detailTokenItem.description}</div> : <></>}
      tokenItemName={tokenName}
      externalUrl={detailTokenItem?.externalUrl}
      customProperties={getNFTProperties()}
    >
      {detailTokenItem ? (
        <img src={detailTokenItem.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} alt={tokenName} />
      ) : (
        <NFTImageSkeleton />
      )}
    </BaseDetail>
  )
}
